import script from "./EditorInput.vue?vue&type=script&lang=js"
export * from "./EditorInput.vue?vue&type=script&lang=js"

import "./EditorInput.vue?vue&type=style&index=0&id=580aefa0&lang=css"

const __exports__ = script;

export default __exports__